<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>
                            Tìm kiếm, tra cứu thông tin tài khoản đơn vị đồng bộ dữ liệu
                        </strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="Đơn vị công tác:"
                                              label-for="unit"
                                              label-cols-md="2"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree class="col-md-6" v-model="searchForm.unitId" allowTraversal :traversalOption.sync="searchForm.unitTraversalOption" ref="unitTree"></unit-tree>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="Nhóm tài khoản đồng bộ:"
                                              label-for="username"
                                              label-cols-md="2"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-md-6 no-padding">
                                        <select2 placeholder="--- Tất cả ---"
                                                 v-model="searchForm.roleId"
                                                 v-bind:options="listRoles"
                                                 allowClear></select2>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="Tên tài khoản:"
                                              label-for="username"
                                              label-cols-md="2"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" id="username" class="col-md-6"
                                                  placeholder="Nhập tài khoản ..."
                                                  v-model="searchForm.username">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="" :label-cols="4" label-cols-md="2">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <br />
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            dataUrl="sync-users"
                            gridName="Danh sách tài khoản đơn vị đồng bộ dữ liệu"
                            ref="syncUserTable">
                        <template v-slot:actions v-if="authorize(['ManageSyncUser'])">
                            <router-link to="./create" tag="button" class="btn btn-primary" size="md">
                                Thêm mới
                            </router-link>
                            <!--<b-button size="md" @click.stop="deletes" variant="danger" :disabled="isShowBtnDelete">
                                Xóa
                            </b-button>-->
                        </template>
                        <template v-slot:cell(isLocked)="row">
                            <b-form-checkbox v-model="row.item.isLocked" @change="updateStatus(row.item, $event)"></b-form-checkbox>
                        </template>
                        <template v-slot:cell(roles)="row">
                            {{ row.item.roles.join(', ') }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button size="sm" :to="{ path: `./${row.item.id}/detail` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <template v-if="authorize(['ManageSyncUser'])">
                                    <b-button size="sm" :to="{ path: `./${row.item.id}/edit` }" title="sửa" variant="primary">
                                        Sửa
                                    </b-button>
                                    <b-button size="sm" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                        Xoá
                                    </b-button>
                                    <!--<b-button size="sm" :to="{ path: `./${row.item.id}/privileges` }" title="phân quyền">
                                        <i class="fa fa-cogs" aria-hidden="true"></i>
                                    </b-button>-->
                                </template>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'ListSyncUser',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    username: null,
                    unitId: this.getUnitTreeIdCache(1),
                    unitTraversalOption: this.getUnitTreeTraversalOptionCache(),
                    roleId: null
                },
                gridOptions: {
                    fields: [
                        { key: 'userName', label: 'Tên tài khoản', sortable: true, sortDirection: 'asc' },
                        { key: 'unitName', label: 'Đơn vị công tác', sortable: true, tdAttr: (key, value, item) => ({ title: item.unitFullName }) },
                        { key: 'roles', label: 'Nhóm tài khoản đồng bộ', sortable: false },
                        { key: 'isLocked', label: 'Khóa tài khoản', sortable: true }
                    ],
                    sortBy: 'userName',
                },
                statuses: [
                    { id: 1, text: 'active' },
                    { id: 0, text: 'inactive' }
                ],
                isShowBtnDelete: true,
                listRoles: []
            }
        },
        computed: {

        },
        created() {
            var vm = this;
            this.$services.get('lookup/sync-roles').done((response) => vm.listRoles = response);
        },
        mounted() {
            this.$watch(
                () => {
                    return this.$refs.syncUserTable.selectedRows
                },
                (val) => {
                    this.isShowBtnDelete = val.length == 0;
                }
            )
        },
        methods: {
            search() {
                this.$refs.syncUserTable.refresh();
            },
            remove(item, index, button) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn xóa tài khoản này?')) {
                    this.$services.delete(`sync-users/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa tài khoản thành công');
                        vm.search();
                    });
                }
            },
            deletes() {
                var vm = this;
                var selectedRows = this.$refs.syncUserTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các tài khoản này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`sync-users?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa các tài khoản thành công');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn tài khoản cần xóa');
                }
            },
            updateStatus(user, checked) {
                var action = checked ? "khóa" : "mở khóa";
                if (confirm('Bạn có chắc muốn ' + action + ' tài khoản này?')) {
                    this.$services.put(`sync-users/${user.id}/status`);
                } else {
                    this.$nextTick(() => user.isLocked = !checked);
                }
            }
        }
    }
</script>
<style scoped>

    .w30 {
        width: 30px;
    }
</style>
